import { UpdateUserPayload, User } from '../../../../types';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { USER_BASE_PATH } from '../constants/userBasePath';

export const postCreateUser = async (
  constructPost: ConstructPost,
  data: UpdateUserPayload,
): Promise<NonPaginatedResponse<User> | undefined> =>
  constructPost<NonPaginatedResponse<User>>(
    `${USER_BASE_PATH}/create`,
    { data },
    { preventDefaultErrorToast: true },
  );
